import Navbar from './navbar.vue'

const navbar = {
    install: function (Vue) {
        Vue.component('navbar', Navbar)
    }
}

export default navbar